/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                              HTTP STATUS                                                                                           ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const OK = 200;
export const PARTIAL_CONTENT = 206;
export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const REQUEST_TIME_OUT = 408;
export const CONFLICT = 409;
export const PRE_CONDITION_FAILED = 412;
export const INTERNAL_SERVER_ERROR = 500;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                              ERRORS CODES                                                                                          ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const NOT_ALLOWED_SITE = 'NOT_ALLOWED_SITE';
export const ALREADY_EXISTS = 'ALREADY_EXISTS';
export const ATM_INVALID = 'ATM_INVALID';
